import React from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const MpesaLoading = ({ isMpesaLoading, onClose }) => {
  return (
    <SlidePanel isOpen={isMpesaLoading} onClose={onClose}>
      <div className="flex flex-col justify-between h-full w-[90%] mx-auto">
        <div
          onClick={onClose}
          className="absolute top-0 right-0 h-[40px] w-[40px] opacity-0 cursor-pointer"
        >
          <X />
        </div>

        {/* Success Section */}
        <div className="mt-24">
          <p className="text-center text-[15px] font-bold mb-5">
            Confirm payment
          </p>

          <div className="h-[80px] bg-[#06B217] rounded flex flex-col items-center justify-center">
            <p className="text-white text-[14px] font-bold">Success!!</p>

            <p className="text-white text-[14px]">
              Follow the M-PESA prompt to complete the payment
            </p>
          </div>
        </div>

        {/* Loader */}
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center gap-[10px] mb-[40px]">
            <span className="inline-block h-[20px] w-[20px] animate-ping rounded-full bg-[#06B217]" />
            <span className="inline-block h-[20px] w-[20px] animate-ping rounded-full bg-[#06B217]" />
            <span className="inline-block h-[20px] w-[20px] animate-ping rounded-full bg-[#06B217]" />
          </div>

          <p className="text-center text-[14px]">
            Hang tight! We’re verifying your payment with M-PESA.
          </p>
        </div>

        {/* Footer */}
        <div className="pb-6">
          <p className="text-[12px] text-[#074073] mb-3">Make sure that:</p>

          <div className="space-y-2">
            <div className="flex items-start gap-3">
              <span className="text-[#16A34A] text-[18px] leading-none mt-[2px]">
                ✔
              </span>
              <span className="text-[14px] text-[#060606]">
                Your M-Pesa SIM is active.
              </span>
            </div>

            <div className="flex items-start gap-3">
              <span className="text-[#16A34A] text-[18px] leading-none mt-[2px]">
                ✔
              </span>
              <span className="text-[14px] text-[#060606]">
                You entered your correct M-Pesa PIN to authorise transaction.
              </span>
            </div>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default MpesaLoading;
